  // Sync variant changes to the ReCharge subscription widget.
  // Listens to both the theme's variant:change event AND directly to option
  // input changes (as a fallback when the theme event doesn't fire).
  (function () {
    var ESSENTIAL_ATTRS = ['default-variant-id', 'product-id', 'store-id', 'template-type'];
    var rechargeDebounceTimer = null;

    function syncRechargeWidget(variantId) {
      if (!variantId) return;

      clearTimeout(rechargeDebounceTimer);
      rechargeDebounceTimer = setTimeout(function () {
        var widgets = document.querySelectorAll('recharge-subscription-widget');
        widgets.forEach(function (widget) {
          // Skip if already showing the correct variant
          if (widget.getAttribute('default-variant-id') === variantId.toString()) return;

          // Read current subscribe/one-time selection from Shadow DOM
          var selectedPlan = null;
          if (widget.shadowRoot) {
            var checked = widget.shadowRoot.querySelector('input[type="radio"]:checked');
            if (checked) {
              selectedPlan = checked.value;
            }
          }

          // Build a brand-new element to force a fresh connectedCallback
          var fresh = document.createElement('recharge-subscription-widget');
          ESSENTIAL_ATTRS.forEach(function (name) {
            if (widget.hasAttribute(name)) {
              fresh.setAttribute(name, widget.getAttribute(name));
            }
          });
          fresh.setAttribute('default-variant-id', variantId.toString());

          widget.parentNode.replaceChild(fresh, widget);

          // Restore subscribe/one-time selection after the new widget initializes
          if (selectedPlan) {
            setTimeout(function () {
              if (fresh.shadowRoot) {
                var radio = fresh.shadowRoot.querySelector(
                  'input[type="radio"][value="' + selectedPlan + '"]'
                );
                if (radio && !radio.checked) {
                  radio.checked = true;
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            }, 500);
          }
        });
      }, 300);
    }

    // Primary: theme's variant change event
    document.addEventListener('theme:variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (variant) {
        syncRechargeWidget(variant.id);
      }
    });

    // Fallback: listen directly to option input changes in case theme event
    // doesn't fire (e.g. after Recharge widget replacement breaks the chain)
    document.addEventListener('change', function (evt) {
      var target = evt.target;
      if (!target || !target.name || target.name.indexOf('options') !== 0) return;

      var jsonEl = document.querySelector('[data-product-json]');
      if (!jsonEl) return;

      try {
        var product = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      var section = target.closest('[data-section-type]') || target.closest('[data-section-id]') || document;
      var checkedInputs = section.querySelectorAll('[name^="options"]:checked');

      if (!checkedInputs || !checkedInputs.length) {
        checkedInputs = document.querySelectorAll('[name^="options"]:checked');
      }

      if (!checkedInputs || !checkedInputs.length) return;

      var selectedOptions = [];
      checkedInputs.forEach(function (input) {
        selectedOptions.push(input.value);
      });

      var matchedVariant = null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var isMatch = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) {
            isMatch = false;
            break;
          }
        }
        if (isMatch) {
          matchedVariant = v;
          break;
        }
      }

      if (matchedVariant) {
        syncRechargeWidget(matchedVariant.id);
      }
    });
  })();
